import { MarketTypes } from 'api/types';
import BottomSheet from 'components/bottom-sheet';
import AddFacilityToFavoriteListForm from '../forms/addFacilityToFavoriteListForm';

interface IAddFacilityToFavoriteListBottomSheet {
  isOpen: boolean;
  marketType: MarketTypes;
  onDismiss: () => void;
  facilityIds: number[];
}

const AddFacilityToFavoriteListBottomSheet = ({
  isOpen,
  onDismiss,
  marketType,
  facilityIds,
}: IAddFacilityToFavoriteListBottomSheet) => {
  return (
    <BottomSheet
      open={isOpen}
      onDismiss={onDismiss}
      snapPoints={({ minHeight, maxHeight }) => [minHeight, maxHeight]}
      blocking={false}
      onClick={(e) => e.stopPropagation()}
    >
      <div style={{ marginBottom: 20 }}>
        <AddFacilityToFavoriteListForm
          onClose={onDismiss}
          marketType={marketType}
          facilityIds={facilityIds}
        />
      </div>
    </BottomSheet>
  );
};

export default AddFacilityToFavoriteListBottomSheet;
